import { Component, OnInit, TemplateRef } from '@angular/core';
import { Conversiontype } from './conversiontype';
import { ConversiontypeService } from './conversiontype.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';
@Component({
  selector: 'app-conversiontype',
  templateUrl: './conversiontype.component.html',
  styleUrls: ['./conversiontype.component.css']
})
export class ConversiontypeComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Conversion Type';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;


  conversiontypeForm: FormGroup;
  conversiontypes: Conversiontype[] = [];
  conversiontypesactive: Conversiontype[] = [];
  conversiontype: Conversiontype;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  conversiontypeModalRef: BsModalRef;
  operation: string;
  userid: number;
  conversiontypeid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;

  key: string = 'conversiontype'; //set default
  reverse: boolean = false;

  constructor(
    private conversiontypeservice: ConversiontypeService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      //console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('ConversionType_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('ConversionType_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('ConversionType_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('ConversionType_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.conversiontypeForm = this.formBuilder.group({
      conversiontypeid: [''],
      conversiontype: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.conversiontypes = [];
    this.conversiontypesactive = [];
    this.conversiontypeservice.Get().subscribe(res => {
      this.conversiontypes = res;
      if (this.showallstatus == true) {
        this.conversiontypes.forEach(data => {
          if (data.active == 1) {
            this.conversiontypesactive.push(data);
          }
        });
        this.conversiontypes = [];
        this.conversiontypes = this.conversiontypesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.conversiontypesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.conversiontypes.forEach(data => {
        if (data.active == 1) {
          this.conversiontypesactive.push(data);
        }
      });
      this.conversiontypes = [];
      this.conversiontypes = this.conversiontypesactive;
    }
    else {
      this.showall = true;
      this.conversiontypes = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedconversiontype");
    let data = arrays.find(ob => ob['name'] === 'Conversion Type');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedconversiontype","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedconversiontype",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.conversiontypeModalRef.hide();
  }
  
  get g() { return this.conversiontypeForm.controls; }

  Post(conversiontype: Conversiontype) {
    
    this.submitted = true;
    // stop here if form is invalid
    if (this.conversiontypeForm.invalid) {
      //console.log(this.g);
      //console.log(this.conversiontypeForm.errors);
    }

    if ((conversiontype.conversiontype.trim() == undefined) || (conversiontype.conversiontype.trim() == '')) {
      this.toastr.error('Conversion Type should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    conversiontype.conversiontype = conversiontype.conversiontype.trim();
    if (this.operation == 'add') {

      conversiontype.createdby = this.userid;
      msg = "Record Added Successfully";
      this.conversiontypeservice.Post(conversiontype).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.conversiontypeModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      conversiontype.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.conversiontypeservice.Put(conversiontype).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.conversiontypeModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.conversiontypeForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.conversiontypeForm.value.active = 1;
    } else {
      this.conversiontypeForm.value.active = 0
    }
  }

  OpenConfirmTemplate(conversiontype, template: TemplateRef<any>) {
    if (conversiontype.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.conversiontype = conversiontype;

          this.Delete();

        }
       
      });

  }
  
  Delete() {
    var msg;
    if (this.conversiontype.active == 0) {
      this.conversiontype.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.conversiontype.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.conversiontype.modifiedby = this.userid;
    this.conversiontypeservice.Delete(this.conversiontype).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
   
  hidePopup() {
    this.conversiontypeModalRef.hide();
  }

  openConversiontypeModal(template: TemplateRef<any>, type, conversiontype?: Conversiontype, ) {
    this.operation = type
    
    if (type == 'update') {
      this.conversiontypeForm.controls['conversiontypeid'].setValue(conversiontype.conversiontypeid);
      this.conversiontypeForm.controls['conversiontype'].setValue(conversiontype.conversiontype);
      this.conversiontypeForm.controls['active'].setValue(conversiontype.active);
      this.conversiontype = conversiontype;
    }
    if (type == 'add') {
      this.conversiontypeForm.controls['conversiontypeid'].setValue(0);
      this.conversiontypeForm.controls['conversiontype'].setValue('');
      this.conversiontypeForm.controls['active'].setValue(1);
    }
    this.conversiontypeModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

   
}
